import {
  ExperimentClient,
  initializeWithAmplitudeAnalytics,
  Variant,
} from '@amplitude/experiment-js-client';

interface ExperimentKeyMap {
  'pricing-pages': 'new' | 'old';
}

export class Experiments {
  private static _experiment: ExperimentClient | undefined;

  private static getExperiment(): ExperimentClient {
    if (typeof window === 'undefined')
      throw new Error('Server-side rendering is not supported');

    if (!this._experiment)
      this._experiment = initializeWithAmplitudeAnalytics(
        process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY ?? '',
      );

    return this._experiment;
  }

  private client: Promise<ExperimentClient>;

  constructor() {
    this.client = Experiments.getExperiment().fetch();
  }

  private defaultMapper = <T>(variant: Variant): T => {
    if (!variant.value) throw new Error('Variant value is undefined');
    if (variant.value === 'off') throw new Error('Variant value is off');

    return variant.value as T;
  };

  async getVariant<K extends keyof ExperimentKeyMap>(
    experimentName: K,
    fallback: ExperimentKeyMap[K],
    mapper: (variant: Variant) => ExperimentKeyMap[K] = this.defaultMapper,
  ): Promise<ExperimentKeyMap[K]> {
    try {
      const client = await this.client;
      const variant = client.variant(experimentName);
      return mapper(variant);
    } catch {
      return fallback;
    }
  }
}
